<template>
  <div class="language-switcher">
    <div class="dropdown">
      <button 
        class="btn btn-outline-secondary dropdown-toggle" 
        type="button" 
        id="languageDropdown" 
        data-bs-toggle="dropdown" 
        aria-expanded="false"
      >
        <i class="fas fa-globe me-2"></i>
        {{ currentLanguageText }}
      </button>
      <ul class="dropdown-menu" aria-labelledby="languageDropdown">
        <li>
          <a 
            class="dropdown-item" 
            href="#" 
            @click.prevent="changeLanguage('tr')"
            :class="{ 'active': currentLanguage === 'tr' }"
          >
            <span class="flag-icon flag-icon-tr me-2"></span>
            {{ $t('common.turkish') }}
          </a>
        </li>
        <li>
          <a 
            class="dropdown-item" 
            href="#" 
            @click.prevent="changeLanguage('en')"
            :class="{ 'active': currentLanguage === 'en' }"
          >
            <span class="flag-icon flag-icon-gb me-2"></span>
            {{ $t('common.english') }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LanguageSwitcher',
  data() {
    return {
      currentLanguage: this.$i18n.locale
    }
  },
  computed: {
    currentLanguageText() {
      return this.currentLanguage === 'tr' ? this.$t('common.turkish') : this.$t('common.english')
    }
  },
  methods: {
    changeLanguage(lang) {
      this.currentLanguage = lang
      this.$i18n.locale = lang
      this.$emit('language-changed', lang)
      // Dil değişikliğini localStorage'a kaydet
      localStorage.setItem('selectedLanguage', lang)
      
      // Draw.io grafiklerini yeniden yükle
      this.reloadDrawioGraphs()
    },
    
    reloadDrawioGraphs() {
      // Mevcut draw.io script'ini kaldır
      const existingScript = document.querySelector('script[src*="viewer.diagrams.net"]')
      if (existingScript) {
        existingScript.remove()
      }
      
      // Yeni script ekle
      setTimeout(() => {
        const newScript = document.createElement("script")
        newScript.setAttribute("src", "https://viewer.diagrams.net/js/viewer-static.min.js")
        document.head.appendChild(newScript)
      }, 100)
    }
  },
  mounted() {
    // Sayfa yüklendiğinde her zaman Türkçe ile başla
    const savedLanguage = localStorage.getItem('selectedLanguage')
    
    if (savedLanguage) {
      this.currentLanguage = savedLanguage
      this.$i18n.locale = savedLanguage
      this.$emit('language-changed', savedLanguage)
    } else {
      // İlk kez açılıyorsa Türkçe ile başla
      this.currentLanguage = 'tr'
      this.$i18n.locale = 'tr'
      localStorage.setItem('selectedLanguage', 'tr')
      this.$emit('language-changed', 'tr')
    }
  }
}
</script>

<style scoped>
.language-switcher {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 1000;
}

.dropdown-item.active {
  background-color: #6c757d;
  color: white;
}

.flag-icon {
  width: 20px;
  height: 15px;
  display: inline-block;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 2px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.2);
}

.flag-icon-tr {
  background-image: url('https://flagcdn.com/w20/tr.png');
}

.flag-icon-gb {
  background-image: url('https://flagcdn.com/w20/gb.png');
}

/* Hover efektleri */
.dropdown-item:hover .flag-icon {
  transform: scale(1.1);
  transition: transform 0.2s ease;
}

/* Aktif dil için özel stil */
.dropdown-item.active .flag-icon {
  border: 2px solid #fff;
  box-shadow: 0 2px 6px rgba(0,0,0,0.3);
}
</style> 